import React from 'react';
import { Card, Statistic, Alert, List, Empty } from 'antd';
import { CheckCircleFilled, WarningFilled } from '@ant-design/icons';

function CumplimientoCronTile({ data, loading }) {
  if (loading) return <Card title="Cumplimiento del cron" loading />;
  if (!data) {
    return (
      <Card title="Cumplimiento del cron">
        <Empty description="Sin datos" />
      </Card>
    );
  }

  const { esperadas, emitidas, gap } = data;
  const ok = esperadas > 0 && emitidas >= esperadas;
  const color = ok ? '#52c41a' : '#faad14';

  return (
    <Card title="Cumplimiento del cron">
      <Statistic
        value={`${emitidas} / ${esperadas}`}
        prefix={
          ok ? (
            <CheckCircleFilled style={{ color }} />
          ) : (
            <WarningFilled style={{ color }} />
          )
        }
        valueStyle={{ fontSize: '2rem', color }}
      />
      <div style={{ color: '#8c8c8c', fontSize: 12, marginTop: 4 }}>
        Solicitudes preventivas emitidas vs clientes automatizados
      </div>

      {gap && gap.length > 0 && (
        <div style={{ marginTop: 12 }}>
          <Alert
            type="warning"
            showIcon
            message={`${gap.length} cliente${gap.length === 1 ? '' : 's'} sin solicitud este mes`}
          />
          <List
            size="small"
            dataSource={gap.slice(0, 5)}
            renderItem={(c) => <List.Item>{c.cliente}</List.Item>}
            style={{ marginTop: 8 }}
          />
          {gap.length > 5 && (
            <div style={{ fontSize: 11, color: '#8c8c8c' }}>
              + {gap.length - 5} más
            </div>
          )}
        </div>
      )}
    </Card>
  );
}

export default CumplimientoCronTile;
